import React,{useEffect} from 'react'
import DocSearchSortRow from './DocSearchSortRow'
import SarasMenu from '../../../../library/repeater/menu/SarasMenu'
import { Icon } from '../../../../library/decor/SarasIcons';
import ActionButton from '../../../../library/input/buttons/button/SarasButton';

const sortDirections = {
    "asc": "Sort Ascending: A to Z",
    "desc": "Sort Descending: Z to A"
}

const DocSearchSort = (props) => {
    const { viewData, onSortSelected, currentKey } = props;

    const [sortKey, setSortKey] = React.useState('');
    const [sortDirectionKey, setSortDirectionKey] = React.useState('asc');

    // console.log("Current sort key:", viewData, currentKey);

    const initialiseSortSelector = () => {
        if(currentKey){
            let sortData = currentKey.split(' ');

            if(sortData.length === 2){
                setSortKey(sortData[0]);
                setSortDirectionKey((sortData[1] || '').toLowerCase());
            }
            else{
                setSortKey('');
                setSortDirectionKey('asc');
            }
        }
        else{
            setSortKey('');
            setSortDirectionKey('asc');
        }
    }

    //ensure state is updated whenever the props are changed by parent
    useEffect(initialiseSortSelector, [viewData, currentKey]);

    // Compute index for current sortKey
    const sortKeys = Object.keys(viewData || {});
    const initialSelectedIndex =
    sortKey && sortKeys.length > 0 ? sortKeys.indexOf(sortKey) : null;
    
    const renderSortKeys = () => {
        let DropdownIcon = Icon['arrowmenu'];

        return (
            <span className='uiActionWithMenu uiFlexBox3 uiHover'>
                {sortKey && viewData[sortKey] ? "By " + viewData[sortKey].dataList.label : 'Default Sort'} <DropdownIcon className='uiBrandColor1'/>
            </span>
        )
    }

    const onSortSelect = (e, index) => {
        let sortRowClicked = viewData[Object.keys(viewData)[index]];
        if (!sortRowClicked) return;
        
        // console.log("fav row object", favRowClicked, favList);
        setSortKey(sortRowClicked.dataList.key);

        onSubmitSort(sortRowClicked.dataList.key, sortDirectionKey);
    }

    const onDirectionToggle = () => {
        const newDirection = sortDirectionKey === 'asc' ? 'desc' : 'asc';
        setSortDirectionKey(newDirection);
        onSubmitSort(sortKey, newDirection);
    }

    const onSubmitSort = (newSort, newDirection) => {
        if(newSort || sortKey ){
            let sortSel = (newSort || sortKey) + " " + (newDirection || sortDirectionKey);
            if(onSortSelected) onSortSelected(sortSel);
        }
    }

    // console.log("sorter", viewData);

    if(!viewData || Object.keys(viewData).length === 0)
        return(null)

    return (
        <div className='uiFlexBox'>
            <SarasMenu menuTrigger={renderSortKeys()} 
            dataList={Object.values(viewData)} 
            menuItem={DocSearchSortRow} 
            initialSelectedIndex={initialSelectedIndex}
            trackSelection={true}
            onSelection={onSortSelect}></SarasMenu>
            <ActionButton 
                onClick={onDirectionToggle}
                starIcon={"sort"}
                startIconStyle={sortDirectionKey === 'asc' ? { transform: 'scaleY(-1)' } : {}}
                tooltip={sortDirections[sortDirectionKey]}
                onlyIcon={true}
                className="uiLink uiIcon"
            />
        </div>
)
}

export default DocSearchSort